'use client';

import { TrackedCTA } from '@/components/TrackedCTA';
import { accountUrl } from '@/lib/config';
import type { PageContext } from '@/lib/cta-tracking';

interface TrackedBlogCTAProps {
    title?: string;
    description?: string;
    buttonText?: string;
    buttonHref?: string;
    pageContext: PageContext;
    ctaPosition?: string;
}

export default function TrackedBlogCTA({
    title = 'Ready to Create Unforgettable Memories?',
    description = 'Start collecting heartfelt video messages from friends and family for your next special occasion.',
    buttonText = 'Get Started Free',
    buttonHref = `${accountUrl}/app/auth/register`,
    pageContext,
    ctaPosition = 'mid',
}: TrackedBlogCTAProps) {
    return (
        <div className="my-12 overflow-hidden rounded-2xl bg-gradient-to-r from-[#2B0A4A] to-[#1B0044] p-8 shadow-xl md:p-12">
            <div className="text-center">
                <h3 className="mb-4 text-3xl font-bold text-white">{title}</h3>
                <p className="mb-6 text-lg text-white/90">{description}</p>
                <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
                    <TrackedCTA
                        href={buttonHref}
                        pageContext={pageContext}
                        ctaContext={{
                            cta_name: 'start_free',
                            cta_label: buttonText,
                            cta_position: ctaPosition,
                            cta_variant: 'primary',
                        }}
                        className="rounded-full bg-[#FFC933] px-8 py-3 font-semibold text-[#2B0A4A] transition-all hover:bg-[#FFD700] hover:shadow-lg"
                    >
                        {buttonText}
                    </TrackedCTA>
                    <TrackedCTA
                        href="/pricing"
                        pageContext={pageContext}
                        ctaContext={{
                            cta_name: 'get_started',
                            cta_label: 'View Pricing',
                            cta_position: ctaPosition,
                            cta_variant: 'secondary',
                        }}
                        className="rounded-full border-2 border-white px-8 py-3 font-semibold text-white transition-all hover:bg-white hover:text-[#2B0A4A]"
                    >
                        View Pricing
                    </TrackedCTA>
                </div>
            </div>
        </div>
    );
}
